module.exports = __webpack_public_path__ + "img/Jo-Malone-London_Brand-Evo_Logo_Black.34cf703b.png";